//state history service function
var StatesHistoryService = function ($state) {
    // states storage keeps all states, visited by user
    var states = [],
        statesToExclude = this.excludedStates;
    //getStateIndex
    //
    //@param {string} state name
    //@param {array} state storage
    //
    //@return {number} index of found state in state storage array if not
    //  found return -1
    //
    //@description
    //Searches passed state name through state storage array and in case if
    //it is found returns index of found element
    function getStateIndex(stateName, stateStorage) {
        var result = -1;
        for (var i = 0; i < stateStorage.length; i++) {
            if (stateStorage[i].name === stateName) {
                result = i;
                break;
            };
        };
        return result;
    };
    //addState
    //
    //@param {string} state name
    //@param {object} state params
    //
    //@description
    //Adds new state into state storage
    function addState(stateName, stateParams) {
        if (statesToExclude.indexOf(stateName) != -1) {
            return;
        }
        //check if passed state exists within storage
        var index = getStateIndex(stateName, states);
        //if it exists - splice array to the index of existing element and update
        //params in other case add new state into storage
        if (index > -1) {
            states = states.slice(0, index + 1);
            states[index].params = stateParams;
        } else {
            states.push({
                name: stateName,
                params: stateParams
            });
        };
    };
    //goBack
    //
    //@description
    //Routes to one state back according to states storage
    function goBack() {
        if (!states.length) {
            return;
        }

        states = states.slice(0, states.length - 1);
        var previousState = states.pop();

        $state.go(
            previousState.name,
            previousState.params
        );
    };
    // goBackManually
    //
    // @description
    // goBackManually method redirect to previous book appointment step or
    // to previous application flow step and avoid redirection to Summary page.
    function goBackManually(fromState, internalStates) {
        if (!states.length) {
            return;
        }
        var previousState;
        var baIndex = internalStates.indexOf(fromState.name) - 1;
        // To redirect manually all states added after SUMMARY page
        // will be removed
        states = states.slice(0, getStateIndex('summary', states));

        if (baIndex >= 0) {
            previousState = {
                name: internalStates[baIndex],
                params: {}
            };
        } else {
            previousState = states.pop();
        };

        $state.go(
            previousState.name,
            previousState.params
        );
    };

    //service methods distributing
    return {
        addState: addState,
        goBack: goBack,
        goBackManually: goBackManually
    };
};
//state history service function injections
StatesHistoryService.$inject = ['$state'];
//state history provider function
var StatesHistoryProvider = function () {
    // states to exclude from caching it is
    // actual for states with substates
    this.excludedStates = [];
    //excludeStates
    //
    //@param {array} array of the states to exclude from cache
    //
    //@description
    //This method sets requires set of states to ignore caching
    //while states changing
    this.excludeStates = function (states) {
        angular.forEach(states, function (state) {
            this.excludedStates.push(state);
        }, this);
    }
    this.$get = StatesHistoryService;
};
module.exports = StatesHistoryProvider;
